import {Routes} from '@angular/router';
import {RoleEnum} from "./@core/enums/role.enum";
import {AuthComponent} from "./@core/auth/auth.component";
import {AuthGuardService} from "./@core/guards/auth-guard.service";
import {RoleGuardService} from "./@core/guards/role-guard.service";

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        redirectTo: 'cases',
        pathMatch: 'full'
      },
      {
        path: 'cases',
        loadChildren: () => import('./@sections/cases/cases.routes').then(r => r.casesRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.CASES_MODERATOR]}
      },
      {
        path: 'battles',
        loadChildren: () => import('./@sections/battles/battles.routes').then(r => r.battlesRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.CASES_MODERATOR]}
      },
      {
        path: 'categories',
        loadChildren: () => import('./@sections/categories/categories.routes').then(r => r.categoriesRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]}
      },
      {
        path: 'discount-system',
        loadChildren: () => import('./@sections/discount-system/discount-system.routes').then(r => r.discountSystemRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]}
      },
      {
        path: 'free-cases',
        loadChildren: () => import('./@sections/free-cases/free-cases.routes').then(r => r.freeCasesRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]}
      },
      {
        path: 'leaders-race',
        loadChildren: () => import('./@sections/leaders-race/leaders-race.routes').then(r => r.leaderRaceRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN]}
      },
      {
        path: 'upgrade',
        loadChildren: () => import('./@sections/upgrade/upgrade.routes').then(r => r.upgradeRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER]}
      },
      {
        path: 'raffles',
        loadChildren: () => import('./@sections/raffles/raffle.routes').then(r => r.rafflesRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.RAFFLE_ADMIN, RoleEnum.RAFFLE_MODERATOR]}
      },
      {
        path: 'analytics',
        loadChildren: () => import('./@sections/analytics/analytics.routes').then(r => r.analyticsRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.RAFFLE_ADMIN, RoleEnum.RAFFLE_MODERATOR]}
      },
      {
        path: 'bonuses',
        loadChildren: () => import('./@sections/bonuses/bonuses.routes').then(r => r.bonusesRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.RAFFLE_ADMIN, RoleEnum.RAFFLE_MODERATOR]}
      },
      {
        path: 'bonus-items',
        loadChildren: () => import('./@sections/bonus-system/bonus-system.routes').then(r => r.bonusSystemRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.RAFFLE_ADMIN, RoleEnum.RAFFLE_MODERATOR]}
      },
      {
        path: 'solitaire',
        loadChildren: () => import('./@sections/solitaire/solitaire.routes').then(r => r.solitaireRoutes),
        canActivate: [RoleGuardService],
        data: {roles: [RoleEnum.OWNER, RoleEnum.CASES_ADMIN, RoleEnum.CASES_MODERATOR, RoleEnum.SOLITAIRE_ADMIN, RoleEnum.SOLITAIRE_MODERATOR]}
      },
    ]
  },
  {
    path: 'login',
    component: AuthComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
